import tiny from './tiny';

// 获取放大图片后的宽和高
export var getEnlargeWidthAndHeight = function (srcWidth, srcHeight) {
  let finalWidth = 0;
  let finalHeight = 0;
  const windowWidth = document.body.clientWidth;
  const windowHeight = document.body.offsetHeight;
  if (srcWidth > windowWidth || srcHeight > windowHeight) {
    if (srcWidth / windowWidth > srcHeight / windowHeight) {
      finalWidth = windowWidth - 200;
      finalHeight = finalWidth / (srcWidth / srcHeight);
    } else {
      finalHeight = windowHeight - 200;
      finalWidth = finalHeight / (srcHeight / srcWidth);
    }
  } else {
    finalWidth = srcWidth;
    finalHeight = srcHeight;
  }

  return {
    width: finalWidth,
    height: finalHeight,
  };
};

let isShowImg = false;

const enlargepic = {
  show(picUrl) {
    const image = new Image();
    const url = picUrl || '';

    if (!url) {
      return false;
    }

    image.onload = function () {
      // 点击放大图标，显示动画效果（图片逐渐放大）
      var obj = getEnlargeWidthAndHeight(image.width, image.height);
      const wrap = `<img src="${url}"` + `width="${obj.width}" height="${obj.height}" />`;
      var obj = {
        url,
        w: obj.width,
        h: obj.height,
      };
      tiny.box.show(wrap, 0, 0, 0, 1, obj);
      isShowImg = true;
    };

    image.src = url;
    return false;
  },
  hide(evt, exceptClass) {
    var exceptClass = exceptClass || '';
    const $target = $(evt.target);

    if (exceptClass && $target.hasClass(exceptClass)) {
      return false;
    }

    if (isShowImg) {
      tiny.box.hide();
      isShowImg = false;
    }
  },
};

export default enlargepic;
